module.exports = __webpack_public_path__ + "img/Avatar-98.fab5000a.svg";